import { useNavigate } from 'react-router-dom';

const AuthHeader = ({ subtitle = "Agency Registration" }) => {
  const navigate = useNavigate();

  return (
    <div className="auth-header">
      {/* Left Side - Logo + Text */}
      <div className="header-left">
        <img 
          src={require('../assets/images/logo.png')} 
          alt="24x7 Taxi" 
          className="header-logo" 
          style={{ width: '55px', height: '55px' }} 
        />
        <div className="header-title">
          {/* 24×7 Taxi  */}
          <span className="header-subtitle"> / {subtitle}</span>
        </div>
      </div>

      {/* Right Side - Back Button */}
      <button 
        onClick={() => navigate('/')}
        className="back-button"
      >
        ← Back to Login
      </button>
    </div>
  );
};

export default AuthHeader;